export default {
  Region: process.env.VUE_APP_REGION,
  UserPoolId: process.env.VUE_APP_USER_POOL_ID,
  ClientId: process.env.VUE_APP_CLIENT_ID
}
